"use client";
import React, { useState } from "react";
import Image from "next/image";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";

// Componente Carousel mejorado para imágenes
function CarouselImage({ images }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [api, setApi] = useState(null);

  // Sincronizar el carousel con el estado
  React.useEffect(() => {
    if (!api) return;

    api.on("select", () => {
      setCurrentIndex(api.selectedScrollSnap());
    });
  }, [api]);

  // Función para navegar a un slide específico
  const goToSlide = (index) => {
    if (api) {
      api.scrollTo(index);
    }
    setCurrentIndex(index);
  };

  return (
    <div className="relative w-full flex flex-col justify-center items-center">
      {/* Contador de imágenes */}
      <div className="absolute top-4 right-4 z-20 bg-black/70 text-white px-3 py-1 rounded-full text-sm font-medium">
        {currentIndex + 1} / {images.length}
      </div>

      <Carousel
        setApi={setApi}
        opts={{
          loop: true,
          align: "center",
        }}
        className="w-full max-w-3xl mx-auto"
      >
        <CarouselContent className="">
          {images.map((image, index) => (
            <CarouselItem key={index} className="pl-2 md:pl-4">
              <div className="relative rounded-xl overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 shadow-lg">
                <div className="aspect-square relative">
                  <Image
                    src={"/images/gsdental/tratamientos/" + image}
                    alt={`Tratamiento dental ${index + 1}`}
                    fill
                    sizes="(max-width: 768px) 90vw, 400px"
                    className="object-cover"
                    loading="lazy"
                  />

                  {/* Overlay sutil con gradiente */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/5 via-transparent to-transparent" />
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>

        {/* Botones de navegación mejorados */}
        <CarouselPrevious className="left-2 w-10 h-10 bg-white/90 hover:bg-white border-0 shadow-md" />
        <CarouselNext className="right-2 w-10 h-10 bg-white/90 hover:bg-white border-0 shadow-md" />
      </Carousel>

      {/* Indicadores de puntos */}
      <div className="flex justify-center mt-4 space-x-2">
        {images.map((_, index) => (
          <div
            key={index}
            className={`size-4 md:size-2 rounded-full transition-all duration-300 outline-none ${index === currentIndex ? "bg-primary-600 w-8 md:w-6" : "bg-gray/50 hover:bg-gray"}`}
            onClick={() => goToSlide(index)}
            aria-label={`Ver imagen ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export function ImageModal({ isOpen, onClose, images = [], title }) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="p-6 bg-white border shadow-2xl">
        {/* Header con título */}
        <div className="mb-4">
          <DialogTitle className="text-2xl font-bold text-gray-900 text-center">
            {`Galería de ${title}` || "Galería de Tratamientos"}
          </DialogTitle>
          <DialogDescription className="sr-only">
            Galería de imágenes de tratamientos dentales
          </DialogDescription>
        </div>

        {/* Contenido del carousel */}
        <div className="flex justify-center">
          <CarouselImage images={images} />
        </div>

        {/* Footer con información adicional */}
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
            Usa las flechas o desliza para navegar entre las imágenes
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
